import store from "@/store";

export default [
    {
        header: 'Component(Sidebar):requests',
        action: 'visit',
        resource: 'requests',
    },
    {
        title: 'Component(Sidebar):sent-requests',
        icon: 'ListIcon',
        route: 'sent-requests',
        showTag: true,
        tagGetter: () => store.getters.activeSentRequestsCount,
        tagVariant: 'secondary',
        activeForRoutes: ['sent-request'],
        action: 'visit',
        resource: 'sent-requests',
    },
    {
        title: 'Component(Sidebar):received-requests',
        icon: 'RepeatIcon',
        route: 'received-requests',
        showTag: true,
        tagGetter: () => store.getters.activeReceivedRequestsCount,
        tagVariant: 'primary',
        activeForRoutes: ['received-request'],
        action: 'visit',
        resource: 'received-requests',
    },
]
